module.exports = __webpack_public_path__ + "img/end-and-side-tables.e65cde4.jpg";